import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Box,
  Card,
  Typography,
  Grid,
  Button,
  IconButton,
  withStyles,
} from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';

// import NotificationsIcon from '@material-ui/icons/NotificationsOutlined';
import InputIcon from '@material-ui/icons/Input';
import {
  // AlertCircle as AlertCircleIcon,
  HelpCircle,
  //  Settings as SettingsIcon,
  User as UserIcon
} from 'react-feather';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { persistor, store } from '../../redux/store';
import history from '../../utils/history';
import SignInService from '../../views/auth/SignInService';
import { getUser } from '../../redux/reducers/user/selectors';
import { translate } from '../../translations/subscriptions.translation';
import { getCurrentLanguage } from '../../utils/utils';

const styles = (theme) => ({
  root: {
    padding: 0
  },
  importButton: {
    marginRight: theme.spacing(1)
  },
  exportButton: {
    marginRight: theme.spacing(1)
  },
  cls1: { fill: '#5c13a4' },
  cls2: { fill: '#fff' },
  cls3: { fill: '#1e1e1e' },
  cardContent: {
    minHeight: 67,
    minWidth: 350,
    margin: '0px 20px 0px 20px',
    padding: '0'
  },
  textSubscription: {
    padding: '5px'
  },
  boxPlan: {
    width: 280,
    margin: '21px 0 10px 20px',
    order: 0,
    [theme.breakpoints.down('md')]: {
      order: 1
    },
    [theme.breakpoints.down('xs')]: {
      margin: '20px 20px 10px 38px',
    }
  },
  boxTier: {
    margin: '20px 20px 10px 20px',
    order: 1,
    [theme.breakpoints.down('md')]: {
      order: 2,
      margin: '20px 20px 10px 28px',
    },
    [theme.breakpoints.down('xs')]: {
      margin: '20px 20px 10px 38px',
    }
  },
  boxMenu: {
    margin: '8px 15px 10px 20px',
    float: 'right',
    order: 1,
    [theme.breakpoints.down('md')]: {
      order: 0,
    },
    [theme.breakpoints.down('xs')]: {
      margin: '8px 15px 10px 30px',
    }
  },
  toolbarContainer: {
    display: 'flex',
    flex: '1 1 auto',
    justifyContent: 'flex-left',
  },
  logoText: {
    textAlign: 'center',
    minWidth: 320,
    maxWidth: 350,
    paddingLeft: 23,
    paddingTop: 23,
    marginBottom: 5,
    [theme.breakpoints.down('md')]: {
      marginLeft: '40%'
    }
  },
  logoBox: {
    backgroundColor: 'rgba(255,255,255,1)',
    flex: '0 0 auto',
    width: 316,
    margin: '0 15px 0 0',
    [theme.breakpoints.down('md')]: {
      width: '100%'
    }
  },
  cardToolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    margin: '0 20px 0 10px',
    [theme.breakpoints.down('md')]: {
      margin: 0,
    }
  },
  itemToolbar: {
    flex: '1 1 auto',
    margin: '10px 20px 0 0',
    [theme.breakpoints.down('md')]: {
      margin: 0,
    }
  },
  plansContainer: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  planTier: {
    order: 0,
    display: 'flex',
    justifyContent: 'flex-start',
    flexFlow: 'row',
    [theme.breakpoints.down('xs')]: {
      order: 1,
      flexFlow: 'column',
    }
  },
  buttonUpload: {
    marginTop: -5
  }
});

class Toolbar extends React.Component {
  constructor(props) {
    super(props);
    this.signOut = this.signOut.bind(this);
    this.getSubscription = this.getSubscription.bind(this);
    this.shouldShowSubscription = this.shouldShowSubscription.bind(this);
    this.getImagesLimit = this.getImagesLimit.bind(this);
  }

  async componentDidMount() {
    this.signInService = await SignInService.getInstance();
  }

  async signOut() {
    await this.signInService.signOut();
    await persistor.purge();
    this.setState({ token: null });
    this.forceUpdate();
    history.push('/');
    window.location.reload();
  }

  getSubscription() {
    if (this.props.user.subscription) {
      const translated = translate(
        this.props.user.subscription,
        getCurrentLanguage(),
        this.props.user.subscription,
      );
      return translated || this.props.user.subscription;
    } else {
      const translated = translate('Free', getCurrentLanguage(), 'Free');
      return translated || 'Free';
    }
  }

  shouldShowSubscription() {
    const limit = this.getImagesLimit();
    const used = this.props.user.limits?.month?.used || 0;
    const usage = (used * 100) / limit;
    return usage > 80 || !this.props.user.subscription || this.props.user.subscription === 'Free';
  }

  getImagesLimit() {
    return this.props.user.limits?.month?.allocated || 1000;
  }

  render() {
    const {
      classes,
      className,
      ...rest
    } = this.props;

    return (
      <div
        className={clsx(classes.root, className)}
        {...rest}
      >
        <Grid container className={classes.toolbarContainer}>
          <Grid item className={classes.logoBox}>
            <div className={classes.logoText}>
              <RouterLink to="/">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2000 278.74">
                  <title>Logo</title>
                  <g id="Layer_2" data-name="Layer 2">
                    <g id="Layer_1-2" data-name="Layer 1">
                      <path className={classes.cls1}
                        d="M198,139.09,271.69,33.8c13.07-18.67,1-33.8-10.13-33.8h-51c-39.87,0-37.79,6.24-57.48,33.8L138.69,54.42,124.25,33.8C104.56,6.24,106.64,0,66.78,0h-51C4.71,0-7.39,15.13,5.68,33.8L79.4,139.09,5.29,244.94c-13.08,18.67,1.11,33.8,10.13,33.8h51c33.63,0,33.63-4.16,57.47-33.8l14.84-21.18,14.83,21.18c23.84,29.64,23.84,33.8,57.47,33.8h51c9,0,23.21-15.13,10.14-33.8Z" />
                      <polygon className={classes.cls2}
                        points="198.96 127.63 143.72 127.63 143.72 56.32 78.81 149.41 134.05 149.41 134.05 220.72 198.96 127.63" />
                      <path className={classes.cls3}
                        d="M350.29,266.57a87.73,87.73,0,0,1-35.11-32.78q-12.65-21-12.65-47.59t12.65-47.59a87.8,87.8,0,0,1,35.11-32.78Q372.76,94,401,94t50.59,11.81a88.13,88.13,0,0,1,34.94,32.78q12.65,21,12.65,47.59t-12.65,47.59a88.06,88.06,0,0,1-34.94,32.78Q429.33,278.39,401,278.38T350.29,266.57Zm83.53-44.26q12.81-13.49,12.81-36.11t-12.81-36.11Q421,136.62,401,136.62t-33,13.47q-13,13.49-13,36.11t13,36.11q13,13.49,33,13.48T433.82,222.31Z" />
                      <path className={classes.cls3}
                        d="M714.2,96.68v179H665v-21.3a68.79,68.79,0,0,1-24.63,17.81,77.56,77.56,0,0,1-31,6.15q-35.28,0-55.91-20.3t-20.63-60.23V96.68h51.91v93.51q0,43.27,36.28,43.27,18.63,0,30-12.15t11.31-36.11V96.68Z" />
                      <path className={classes.cls3}
                        d="M925,114q20.47,20,20.47,59.24v102.5H893.57V181.21q0-21.3-9.31-31.78t-27-10.49q-19.63,0-31.28,12.15T814.37,187.2v88.52H762.45v-179H812v21a69,69,0,0,1,25.62-17.47A89.4,89.4,0,0,1,871.28,94Q904.55,94,925,114Z" />
                      <path className={classes.cls3}
                        d="M1107.89,267.07a53.45,53.45,0,0,1-18.8,8.49,95.43,95.43,0,0,1-23.46,2.82q-32,0-49.42-16.3t-17.48-47.92V140.61H971.11V100.67h27.62V57.08h51.92v43.59h44.59v39.94h-44.59v72.88q0,11.32,5.82,17.47t16.48,6.16q12.3,0,21-6.66Z" />
                      <path className={classes.cls3}
                        d="M1305.9,200.84H1170.46a42.09,42.09,0,0,0,17.3,26.29q13.65,9.66,34,9.66a68.78,68.78,0,0,0,24.79-4.16,60.14,60.14,0,0,0,20.13-13.15l27.63,30q-25.3,28.95-73.88,28.95-30.3,0-53.58-11.81t-36-32.78q-12.64-21-12.64-47.59,0-26.28,12.48-47.42A87.41,87.41,0,0,1,1165,105.83Q1186.75,94,1213.72,94q26.28,0,47.59,11.31a82.68,82.68,0,0,1,33.44,32.45q12.15,21.14,12.15,49.09Q1306.9,187.86,1305.9,200.84Zm-121.47-57.57q-12,10-14.64,27.29H1258q-2.67-17-14.64-27.12t-29.29-10.15Q1196.41,133.29,1184.43,143.27Z" />
                      <path className={classes.cls3}
                        d="M1416.22,100.67Q1432,94,1452.66,94v47.92q-8.65-.66-11.64-.67-22.3,0-35,12.48t-12.64,37.44v84.53h-51.92v-179h49.59v23.63A57.61,57.61,0,0,1,1416.22,100.67Z" />
                    </g>
                  </g>
                </svg>
              </RouterLink>
            </div>
          </Grid>
          <Grid item className={classes.itemToolbar}>
            <Card className={classes.cardToolbar}>
              <Grid container className={classes.plansContainer}>
                {
                  this.shouldShowSubscription()
                    ? (
                      <Grid item className={classes.planTier}>
                        <Grid item className={classes.boxPlan}>
                          <Typography
                            align="left"
                            color="textPrimary"
                            variant="h4"
                            display="inline"
                            className={classes.textSubscription}
                          >
                            <FormattedMessage id="label.subscription" defaultMessage="Subscription plan"/>
                            :
                            {' '}
                            { this.getSubscription() }
                          </Typography>
                        </Grid>
                        <Grid item className={classes.boxTier}>
                          <Typography
                            align="left"
                            color="textPrimary"
                            variant="h4"
                            display="inline"
                            className={classes.textSubscription}
                          >
                            {this.props.user.limits?.month?.used || 0}
                            /
                            {this.getImagesLimit()}
                            &nbsp;&nbsp;
                          </Typography>
                          <Button
                            className={classes.buttonUpload}
                            color="primary"
                            variant="contained"
                            href="/app/account"
                          >
                            <FormattedMessage id="label.upgrade" defaultMessage="Upgrade"/>
                          </Button>
                        </Grid>
                      </Grid>
                    )
                    : <Grid item className={classes.planTier}/>
                }
                <Grid item className={classes.boxMenu}>
                  <Box>
                    <IconButton
                      color="inherit"
                      title="Account"
                      activeClassName={classes.active}
                      className={classes.button}
                      href="/app/account"
                    >
                      <UserIcon />
                    </IconButton>
                    <IconButton
                      color="inherit"
                      title="Help"
                      className={classes.button}
                      href="/app/help"
                    >
                      <HelpCircle />
                    </IconButton>
                    {/* <IconButton color="inherit" title="Notification">
                    <Badge
                      badgeContent={1}
                      color="primary"
                      variant="dot"
                    >
                      <NotificationsIcon />
                    </Badge>
                  </IconButton> */}
                    <IconButton color="inherit" title="Logout" onClick={this.signOut}>
                      <InputIcon />
                    </IconButton>
                  </Box>
                </Grid>
              </Grid>
            </Card>
          </Grid>
        </Grid>
      </div>
    );
  }
}

Toolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  user: PropTypes.object,
};

export default connect(getUser, {})(withStyles(styles)(Toolbar));
